import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.initFlatpickr();
    
    // Re-initialize when Turbo loads a new page
    document.addEventListener('turbo:load', () => {
      console.log('Turbo load detected, reinitializing flatpickr');
      this.initFlatpickr();
    });
  }

  disconnect() {
    // Clean up event listener
    document.removeEventListener('turbo:load', this.initFlatpickr);
  }

  initFlatpickr() {
    this.inputTargets.forEach((input) => {
      if (!input._flatpickr) {
        const fp = flatpickr(input, {
          locale: Spanish,
          dateFormat: "Y-m-d",
          altInput: true,
          allowInput: false,
          altFormat: "d-m-Y",
          defaultDate: input.value || null,
          onChange: () => {
            input.form?.requestSubmit();
            this.toggleIcons(input);
          },
        });

        this.addClearButton(input, fp);
        this.toggleIcons(input);
      }
    });
  }

  addClearButton(input, fp) {
    // Crear el botón "x"
    const clearBtn = document.createElement("span");
    clearBtn.textContent = "✕";
    clearBtn.classList.add("clear-button");
    clearBtn.style.position = "absolute";
    clearBtn.style.right = "15px";
    clearBtn.style.top = "50%";
    clearBtn.style.transform = "translateY(-50%)";
    clearBtn.style.cursor = "pointer";
    clearBtn.style.display = "none"; // se muestra solo si hay valor

    // Insertar el botón dentro del contenedor padre del input
    input.parentElement.style.position = "relative";
    input.parentElement.appendChild(clearBtn);

    // Crear el handler y guardarlo para poder removerlo después
    const clickHandler = (e) => {
      e.preventDefault();
      fp.clear();
      input.form?.requestSubmit();
      this.toggleIcons(input);
    };

    clearBtn.addEventListener("click", clickHandler);
    
    // Guardar referencias para poder limpiar después
    input._clearBtn = clearBtn;
    input._clearBtnClickHandler = clickHandler;
  }

  toggleIcons(input) {
      const hasValue = input.value.trim() !== "";

      if (input._clearBtn) {
          input._clearBtn.style.display = hasValue ? "inline-flex" : "none";
      }

      const arrow = input.parentElement.querySelector(".fa-sort-down.position-absolute");
      if (arrow) {
          arrow.style.display = hasValue ? "none" : "inline";
      }

      // Apuntar al input visible que genera flatpickr
      const visibleInput = input.nextElementSibling;
      if (visibleInput && visibleInput.classList.contains("form-control")) {
          if (hasValue) {
              visibleInput.style.setProperty("background-color", "rgb(240, 240, 240)", "important");
          } else {
              visibleInput.style.setProperty("background-color", "white", "important");
          }
      }
  }

  disconnect() {
    // Limpiar instancias de flatpickr y elementos del DOM cuando se desconecta
    this.inputTargets.forEach((input) => {
      // Destruir la instancia de flatpickr
      if (input._flatpickr) {
        input._flatpickr.destroy();
        input._flatpickr = null;
      }

      // Remover el botón clear
      if (input._clearBtn) {
        if (input._clearBtnClickHandler) {
          input._clearBtn.removeEventListener("click", input._clearBtnClickHandler);
          input._clearBtnClickHandler = null;
        }
        input._clearBtn.remove();
        input._clearBtn = null;
      }
    });
  }
}
